import { TableRow, TableCell, Typography } from '@mui/material'
import React from 'react'
import getLocaleCurrencyForAmount from '../../../../../utils/getLocaleCurrencyForAmount'
import {
  convertTwoDecimalStringToBig,
  formatBigFixedTwoDecimals,
} from '../../../../../utils/bigJSHelper'

type TutorLicensingDetailsBalanceRowsProps = {
  labels: {
    totalOwed: string
    totalPaid: string
    balance: string
    licensingDue: string
  }
  values: {
    totalOwed: string
    totalPaid: string
    balance: string
    licensingDue: string
  }
  currencyCode: string
}

export const TutorLicensingDetailsBalanceRows: React.FC<
  TutorLicensingDetailsBalanceRowsProps
> = (props) => {
  return (
    <>
      <TableRow>
        <TableCell colSpan={3} sx={{ border: 'none' }}>
          {props.labels.totalOwed}
        </TableCell>
        <TableCell
          sx={{
            fontWeight: 'bold',
            textAlign: 'right',
            border: 'none',
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',
              fontFamily: 'inherit',
              fontSize: '1.3rem',
            }}
          >
            {getLocaleCurrencyForAmount(
              props.values.totalOwed,
              props.currencyCode
            )}
          </Typography>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell colSpan={3} sx={{ border: 'none' }}>
          {props.labels.totalPaid}
        </TableCell>
        <TableCell align="right" sx={{ border: 'none' }}>
          {getLocaleCurrencyForAmount(
            props.values.totalPaid,
            props.currencyCode
          )}
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell colSpan={3}>{props.labels.balance}</TableCell>
        <TableCell
          sx={{
            fontWeight: 'bold',
            textAlign: 'right',
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',
              fontFamily: 'inherit',
              fontSize: '1.3rem',
            }}
          >
            {getLocaleCurrencyForAmount(
              formatBigFixedTwoDecimals(
                convertTwoDecimalStringToBig(props.values.totalOwed).minus(
                  props.values.totalPaid
                )
              ),
              props.currencyCode
            )}
          </Typography>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell colSpan={3}>{props.labels.licensingDue}</TableCell>
        <TableCell
          sx={{
            fontWeight: 'bold',
            textAlign: 'right',
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',
              fontFamily: 'inherit',
              fontSize: '1.3rem',
            }}
          >
            {getLocaleCurrencyForAmount(
              props.values.licensingDue,
              props.currencyCode
            )}
          </Typography>
        </TableCell>
      </TableRow>
    </>
  )
}
